import { render, staticRenderFns } from "./RecycoButton.vue?vue&type=template&id=434325a3&scoped=true&"
import script from "./RecycoButton.vue?vue&type=script&lang=js&"
export * from "./RecycoButton.vue?vue&type=script&lang=js&"
import style0 from "./RecycoButton.vue?vue&type=style&index=0&id=434325a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434325a3",
  null
  
)

export default component.exports